import { render } from "./ListRepairParts.vue?vue&type=template&id=4c466762"
import script from "./ListRepairParts.vue?vue&type=script&lang=js"
export * from "./ListRepairParts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__